import { render, staticRenderFns } from "./PublishModal.vue?vue&type=template&id=2564a346&scoped=true&"
import script from "./PublishModal.vue?vue&type=script&lang=js&"
export * from "./PublishModal.vue?vue&type=script&lang=js&"
import style0 from "./PublishModal.vue?vue&type=style&index=0&id=2564a346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2564a346",
  null
  
)

export default component.exports